import { defineRecipe } from '@chakra-ui/react/styled-system';

import { base, defaultVariants, sizePadding, variants } from '../common/InputAndTextarea.common';
import { rem } from '../themeUtils';

// Single recipe shared by the raw <Textarea> atom and BitkitTextArea (both get it via Chakra's
// `<Textarea>`, which applies the `textarea` recipe by key).
const textareaRecipe = defineRecipe({
  className: 'textarea',
  base: {
    ...base,
    // A raw <textarea> is inline-block with baseline alignment, which reserves
    // descender space below it and inflates the gap to the helper text. Block
    // layout removes that phantom space.
    display: 'block',
    minBlockSize: 'var(--input-height)',
  },
  variants: {
    size: {
      md: {
        ...variants.size.md,
        '&[rows="1"]': { paddingBlock: rem(9) },
      },
      lg: variants.size.lg,
    },
  },
  defaultVariants,
});

// Placement for the status icon (error/warning) that BitkitTextArea overlays on the textarea.
// Derived from the text padding (`sizePadding`) so the icon aligns with the first line of text,
// and paddingInlineEnd reserves room for it: text padding + icon size + gap.
const ICON_GAP = 8;
const iconSize = { md: 16, lg: 24 } as const;

export const textareaStatusIcon = {
  md: {
    insetBlockStart: rem(sizePadding.md.block),
    insetInlineEnd: rem(sizePadding.md.inline),
    paddingInlineEnd: rem(sizePadding.md.inline + iconSize.md + ICON_GAP),
  },
  lg: {
    insetBlockStart: rem(sizePadding.lg.block),
    insetInlineEnd: rem(sizePadding.lg.inline),
    paddingInlineEnd: rem(sizePadding.lg.inline + iconSize.lg + ICON_GAP),
  },
};

export default textareaRecipe;
